<template>
    <BrowserCheck />

    <router-view />

    <!-- Aurora Toast · 对齐 ToVid FeedbackHost -->
    <AuroraToastHost />

    <!-- 拖拽过程中的全局公共临时div -->
    <!-- 全局所有业务场景中凡是涉及到拖拽元素的，都建议使用此div，并将拖拽内容插入到此div中 -->
    <!-- 不要在业务组件内创建拖拽过程中的临时div，因为拖拽div使用fixed定位，而fixed受父、祖级元素的定位影响 -->
    <div id="dragContentCommon" class="drag-content-common"></div>
</template>

<script lang="ts" setup>
import { useViewportVideoHotkey } from "@/hooks/useViewportVideoHotkey";
import AuroraToastHost from "@/components/AuroraToastHost.vue";

useViewportVideoHotkey();
</script>

<style lang="scss" scoped>
.drag-content-common {
    display: none;
    // display: flex;
    flex-direction: row;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    background-color: red;
    pointer-events: none;
    z-index: 10;
}
</style>
